import type { User } from '../types';

/** IA nav, Listings entry point and Flexible Properties page; ZRAM users keep the legacy experience. */
export const isListingCentricViewEnabled = (user?: Pick<Partial<User>, 'loggedIn' | 'isEnterpriseCustomer'> | null) =>
  Boolean(user?.loggedIn) && !user?.isEnterpriseCustomer;
